/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import AiRecorder from './AiRecorder/index'
import LeadsApp from './LeadsApp/index'
import NewCalendar from './NewCalendar/index'
import NewCommsAutomationAction from './NewCommsAutomationAction/index'
import NewSearchAction from './NewSearchAction/index'
import NewTasks from './NewTasks/index'
import React from 'react'
import TableX from 'DesignSystem/TableX/react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/FeatureFlags/Content",
  value
  
}) {
  return (<React.Fragment
>
<NewCalendar
  viewPath={`${viewPath}/NewCalendar`}
/>
<LeadsApp
  viewPath={`${viewPath}/LeadsApp`}
/>
<AiRecorder
  viewPath={`${viewPath}/AiRecorder`}
/>
<NewTasks
  viewPath={`${viewPath}/NewTasks`}
/>
<NewCommsAutomationAction
  viewPath={`${viewPath}/NewCommsAutomationAction`}
/>
<NewSearchAction
  viewPath={`${viewPath}/NewSearchAction`}
/>
<TableX
  viewPath={`${viewPath}/TableX`}
 value={value}
/>
{children}
</React.Fragment>)
}